var render, staticRenderFns
import script from "./editor_state_observer.vue?vue&type=script&lang=js&vue3"
export * from "./editor_state_observer.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports